import apiClient from '../apiClient';
import { GET_SYSTEM_MARGIN_LIST_URL } from '../apiUrl';

const getSystemMarginListApi = code => {
  return apiClient.get(GET_SYSTEM_MARGIN_LIST_URL(code));
};

export default getSystemMarginListApi;
